import { SVGProps, memo } from 'react';
const ReportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "24"} height={props.height || "24"} viewBox="0 0 24 24" fill={props.fill || "none"} xmlns="http://www.w3.org/2000/svg">
    <g id="WarningAmberOutlined">
      <g id="Vector">
        <path d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5Z" fill={props.fill || "#424242"}/>
        <path d="M13 16.5H11V18.5H13V16.5Z" fill={props.fill || "#424242"}/>
        <path d="M13 10.5H11V15.5H13V10.5Z" fill={props.fill || "#424242"}/>
      </g>
    </g>
  </svg>
);

export default memo(ReportIcon);
